define("shared/components/shared/post/profile-selector/social-profile-state/index", ["exports", "@ember/object", "@glimmer/tracking", "shared/utils/post/duplicate-post"], function (_exports, _object, _tracking, _duplicatePost) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  0; //eaimeta@70e063a35619d71f0,"@ember/object",0,"@glimmer/tracking",0,"shared/utils/post/duplicate-post"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let SocialProfileState = _exports.default = (_dec = (0, _object.computed)('socialProfile', 'post', 'post.{postMediaItems.[],isEmptyDraft}'), _dec2 = (0, _object.computed)('state', 'socialProfile.isTwitter', 'auth.currentAccount.rolloutTwitterSunset'), _dec3 = (0, _object.computed)('socialProfile', 'post', 'post.{postMediaItems.[],isEmptyDraft}'), (_class = class SocialProfileState {
    constructor(socialProfile, post, auth) {
      let isSelected = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "isSelected", _descriptor2, this);
      _initializerDefineProperty(this, "socialProfile", _descriptor3, this);
      _initializerDefineProperty(this, "post", _descriptor4, this);
      this.socialProfile = socialProfile;
      this.post = post;
      this.auth = auth;
      this.isSelected = isSelected;
    }
    get state() {
      if (!this.post) {
        return;
      }
      return (0, _duplicatePost.canDuplicatePost)(this.post, this.socialProfile, this.auth);
    }
    get isAvailable() {
      if (this.socialProfile.isTwitter && this.auth.currentAccount?.rolloutTwitterSunset) {
        return false;
      }
      return this.state === _duplicatePost.PostDuplicationState.Available;
    }
    get unsupportedMedia() {
      return (0, _duplicatePost.hasUnsupportedMedia)(this.post, this.socialProfile);
    }
    toggleSelect() {
      this.isSelected = !this.isSelected;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isSelected", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "socialProfile", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "post", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "state", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "state"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAvailable", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "isAvailable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unsupportedMedia", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "unsupportedMedia"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSelect", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSelect"), _class.prototype)), _class));
});